import forEach from 'lodash/fp/forEach';

import sagas from '~/features/base/sagas';
import createSagaMiddleware from 'redux-saga';

export const setupSagas = () => createSagaMiddleware();
export const activeSagas = (sagaMiddleware) => forEach(saga => sagaMiddleware.run(saga), sagas);
